import React from 'react';
import { Check } from 'lucide-react';

const TrialStepsHeader: React.FC = () => (
  <div className="mx-auto mb-8 flex max-w-md items-center justify-center">
    <div className="flex w-24 flex-none flex-col items-center gap-1.5 text-center">
      <span className="flex h-[26px] w-[26px] items-center justify-center rounded-full bg-map-green">
        <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
      </span>
      <span className="text-[11.5px] font-semibold text-map-green">Account created</span>
    </div>
    <div className="relative top-[-9px] mx-1 h-0.5 flex-1 bg-map-green" />
    <div className="flex w-24 flex-none flex-col items-center gap-1.5 text-center">
      <span className="flex h-[26px] w-[26px] items-center justify-center rounded-full bg-primary text-xs font-bold text-white shadow-[0_0_0_4px_rgba(138,48,51,0.14)]">
        2
      </span>
      <span className="text-[11.5px] font-bold text-primary">Choose plan</span>
    </div>
    <div className="relative top-[-9px] mx-1 h-0.5 flex-1 bg-gray-200" />
    <div className="flex w-24 flex-none flex-col items-center gap-1.5 text-center">
      <span className="flex h-[26px] w-[26px] items-center justify-center rounded-full border-2 border-gray-200 bg-white text-xs font-bold text-gray-400">
        3
      </span>
      <span className="text-[11.5px] font-semibold text-gray-400">Add card</span>
    </div>
  </div>
);

export default TrialStepsHeader;
